import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-quantity-in-stock',
  templateUrl: './header-column-quantity-in-stock.component.html',
  styleUrls: ['./header-column-quantity-in-stock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnQuantityInStockComponent extends HeaderColumnComponent {}
